import React from 'react'

const ManageCourses = () => {
    return (
        <div id="page-admin-users" className="page-admin">
            <div className="card">
                <div className="card-body bg-white">

                    <div id="citymanage">
                        <p className="top-msg">City List</p>
                        <span className="pagebanner">26 items found, displaying 1 to 25.</span>
                        <span className="pagelinks">
                            [First/Prev] <strong>1</strong>,{" "}
                            <a href="?d-443839-p=2" title="Go to page 2">
                                2
                            </a>{" "}
                            [<a href="?d-443839-p=2">Next</a>/<a href="?d-443839-p=2">Last</a>]
                        </span>
                        <table cellSpacing={0} id="cities" className="table" cellPadding={0}>
                            <thead>
                                <tr>
                                    <th className="sortable sorted order1">
                                        <a href="?d-443839-s=0&d-443839-o=1">City</a>
                                    </th>
                                    <th className="sortable">
                                        <a href="?d-443839-s=1&d-443839-o=2">State</a>
                                    </th>
                                    <th className="sortable">
                                        <a href="?d-443839-s=2&d-443839-o=2">Active</a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=24">Ballia</a>
                                    </td>
                                    <td>UP</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=19">Buenos Aires</a>
                                    </td>
                                    <td>Argentina</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=7">Chicago</a>
                                    </td>
                                    <td>Illinois</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=25">Goarkpur</a>
                                    </td>
                                    <td>UP India</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=20">Guadalajara</a>
                                    </td>
                                    <td>Mexico</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=23">jaipur</a>
                                    </td>
                                    <td>rajasthan </td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=21">Lucknow</a>
                                    </td>
                                    <td>UP</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=18">Medellin</a>
                                    </td>
                                    <td>Antioquia </td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=9">Moscow</a>
                                    </td>
                                    <td>Russia</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=22">Mumbai</a>
                                    </td>
                                    <td>Maharashtra</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=8">New York</a>
                                    </td>
                                    <td>New York</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=3">Orange County</a>
                                    </td>
                                    <td>California</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=6">Palm Springs</a>
                                    </td>
                                    <td>California</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=10">Paris</a>
                                    </td>
                                    <td>France</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=26">Patna</a>
                                    </td>
                                    <td>Bihar</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=1">Portland</a>
                                    </td>
                                    <td>Oregon</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=4">Sacramento</a>
                                    </td>
                                    <td>California</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=5">San Francisco</a>
                                    </td>
                                    <td>California</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=11">Sofia</a>
                                    </td>
                                    <td>Bulgaria</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=12">Test</a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=13">Test Open</a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=16">Test Playoffs</a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=14">
                                            Test Registration Open
                                        </a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="even">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=17">
                                            Test Season Completed
                                        </a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                                <tr className="odd">
                                    <td>
                                        <a href="/carter/registrationCity.html?id=15">Test Tournament Play</a>
                                    </td>
                                    <td>OR</td>
                                    <td style={{ width: "10%", paddingLeft: 15 }}>
                                        <input type="checkbox" disabled="disabled" defaultChecked="checked" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <a style={{ marginRight: 20 }} href="manageCourse.html">
                            Manage Courses
                        </a>
                        <a href="registrationCity.html">Add New City</a>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ManageCourses